module.exports = __webpack_public_path__ + "static/media/zoom-in.95221d5d.svg";